import React from "react";
import PageHero from "@/components/PageHero";
import ServicesGrid from "@/components/sections/ServicesGrid";
import ProcessFlow from "@/components/sections/ProcessFlow";
import CTA from "@/components/sections/CTA";
import { useT } from "@/lib/i18n";

export default function Services() {
  const { t } = useT();
  return (
    <div data-testid="page-services">
      <PageHero
        eyebrow={t("nav.services")}
        title={
          <>
            {t("page.services.title.a")}{" "}
            <span className="text-[color:var(--zp-text-3)]">{t("page.services.title.b")}</span>
          </>
        }
        subtitle={t("page.services.sub")}
        animation="all"
      />
      <ServicesGrid heading={false} animated />
      <ProcessFlow />
      <CTA />
    </div>
  );
}
